import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/sales-rep/compound/buildings";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/sales-rep/compound/dropdown/Building?status=1";
const apiToggleStatus = API_BASE_URL_ENV() + "/sales-rep/compound/toggle-activation/Building/";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
   
    getDropDown=(id)=>{
        if(id){
            return  http.get(`${apiDropDownEndpoint}&compound_ids=${id}`) 
        }else{
            return  http.get(apiDropDownEndpoint) 

        }
      }
      toggleStatus=(id)=>{
        return http.get(`${apiToggleStatus}${id}`)
      }
}